<template>
    <app-cmp-tabs default="content" v-if="this.element">
        <div class="flex" slot-scope="{ toggle, active }">
            <app-cmp-tabs-trigger name="content" :handle-click="toggle" :active="active">
                <i class="fal fa-file-alt"></i>Content
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="box" :handle-click="toggle" :active="active">
                <i class="fal fa-th-large"></i>Box Model
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="design" :handle-click="toggle" :active="active">
                <i class="fal fa-pencil-alt"></i>Design
            </app-cmp-tabs-trigger>
        </div>
        <div slot="items" slot-scope="{ active }">
            <app-cmp-tabs-content name="content" :active="active">
                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    Properties
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-full">
                        <label class="text-xs text-grey-darker">
                            Image
                        </label>
                        <app-field-file
                            class="reset mt-2"
                            v-model="element.object.values.image"
                            :types="{images: true, files: false}"
                        />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Alt
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-text
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            name="alt"
                            placeholder=""
                            v-model="element.object.values.alt"
                        />
                    </div>
                </div>
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="box" :active="active">
                <app-cmp-box-model
                    :element="element.object"
                />

                <app-cmp-border
                    :element="element.object"
                />
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="design" :active="active">
                <app-cmp-design
                    :element="element.object"
                />
            </app-cmp-tabs-content>
        </div>
    </app-cmp-tabs>
</template>

<script>
    import CmpTabs from '@/components/composer/Tabs/Tabs';
    import CmpTabsTrigger from '@/components/composer/Tabs/TabsTrigger';
    import CmpTabsContent from '@/components/composer/Tabs/TabsContent';

    import TextField from '@/components/fields/inputs/Text';
    import ToggleField from '@/components/fields/inputs/Toggle';
    import FileField from '@/components/fields/inputs/File';

    import CmpBoxModel from '@/components/composer/Forms/Partials/BoxModel';
    import CmpBorder from '@/components/composer/Forms/Partials/Border';
    import CmpDesign from '@/components/composer/Forms/Partials/Design';

    export default {
        components: {
            'app-cmp-tabs': CmpTabs,
            'app-cmp-tabs-trigger': CmpTabsTrigger,
            'app-cmp-tabs-content': CmpTabsContent,
            'app-cmp-box-model': CmpBoxModel,
            'app-cmp-border': CmpBorder,
            'app-cmp-design': CmpDesign,
            'app-field-text': TextField,
            'app-toggle-field': ToggleField,
            'app-field-file': FileField,
        },
        props: {
            element: {
                type: Object,
                required: true
            }
        },
        data: () => ({
            fields: {
                plain: {
                    name: 'Standard image',
                    attribute: 'plain'
                },
                image: {
                    name: 'Image',
                    attribute: 'image'
                },
                alt: {
                    name: 'Alt Text',
                    attribute: 'alt'
                },
                title: {
                    name: 'Title',
                    attribute: 'title'
                }
            }
        }),
    }
</script>



// WEBPACK FOOTER //
// src/components/composer/Elements/HeaderImageSettings.vue